module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search":"Search","country":"Country"},"fr":{"search":"Rechercher","country":"Pays"},"de":{"search":"Forschen","country":"Zahlt"}}')
  delete Component.options._Ctor
}
